export const environment = {
  production: false,
  apiUrl: 'https://api.transparencia.educacao.homologacao.imap.org.br/api',
  name: 'homologacao'
};